import React from "react";

export const showValidation = (field) => {
  let { element } = field;
  let message = null;
  let { validationMessage, valid, touched, hintMessage } = element;

  if (touched && !valid && validationMessage) {
    message = (
      <div className="error-message">
        <span>{validationMessage}</span>
      </div>
    );
  } else if (hintMessage) {
    message = (
      <div className="hint-message">
        <span>{hintMessage}</span>
      </div>
    );
  }

  return message;
};



// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/utilities/showValidation.jsx